import React from 'react';
import styled from '@emotion/styled';

import Logos from './Logos';
import CTA from './CTA';
import Hero from './Hero';
import PageLayout from '../PageLayout';
import Stacheldraht from '../Stacheldraht';

import { mediaPhone, minDesktop } from '../styles/breakpoints';
import { HeadlineFont } from '../styles/fonts';

const Header = styled.header`
  position: relative;

  padding-top: 25px;

  text-align: center;

  ${minDesktop} {
    top: 0;
    left: 25px;
  }
`;

const Content = styled.div`
  position: relative;

  padding-top: 60px;
  padding-bottom: 40px;
`;

const HeroStyled = styled(Hero)`
  display: inline-block;

  z-index: 20;

  ${mediaPhone} {
    order: 20;
    position: relative;
    top: -80px;
    margin-bottom: -80px;
  }

  @media (max-width: 576px) { margin-bottom: -100px; }
  @media (max-width: 475px) { margin-bottom: -120px; }
`;

const CTAContainer = styled.div`
  display: block;
  @media (max-width: 979px) {
    margin-top: 85px;
  }
`;

const CTAStyled = styled(CTA)`
  display: inline-block;

  position: absolute;
  z-index: 10;

  top: -40px;
  left: 50px;

  @media (max-width: 979px) {
    position: relative;
    top: auto;
    left: auto;
  }
`;

const StacheldrahtLeftBig = styled(Stacheldraht)`
  margin-top: -130px;

  @media (min-width: 980px) {
    margin-left: -290px;
  }
`;

const SubTitle = styled.div`
  transform: rotate(-6deg);
  display: inline-block;
  width: 340px;

  @media (max-width: 979px) {
    position: relative;
    top: -295px;
    left: -15px;
    margin-top: -95px;
  }
  @media (min-width: 980px) {
    position: absolute;
    top: 150px;
    left: 68%;
  }
  @media (min-width: 1100px) {
    left: 66%;
  }
`;

const SubTitleHeadline = styled.h2`
  ${HeadlineFont};
  display: inline-block;
  max-width: 360px;
  line-height: 1.1;
  text-transform: uppercase;
  font-size: 26px;
  text-align: left;
`;

const SubTitleHeadlineB = styled.b`
  display: inline-block;
  font-weight: 400;
  color: #fff;
  background-color: #000;
  padding: 0 6px;
`;

const PageHeader = () => (
  <Header>
    <PageLayout>
      <Logos />
      <Content>
        <CTAContainer>
          <CTAStyled />
        </CTAContainer>
        <div>
          <SubTitle>
            <SubTitleHeadline>
              Vier Lerneinheiten zum Thema
              <br />
              <SubTitleHeadlineB>
                nachhaltiger Modekonsum
              </SubTitleHeadlineB>
              <br />
              für die SekundarStufe
            </SubTitleHeadline>
            <Stacheldraht small />
          </SubTitle>
        </div>
        <HeroStyled />
        <StacheldrahtLeftBig />
      </Content>
    </PageLayout>
  </Header>
);

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader/PageHeader.js